import React from "react";
import ReactIframeResizer from "react-iframe-resizer-super";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: theme.spacing(0, 10),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 2),
    },
  },
  iframe: {
    border: "none",
    height: 700,
  },
}));

const Pelletheizung3DIframe = () => {
  // eslint-disable-line
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <ReactIframeResizer
        iframeResizerUrl={false}
        iframeResizerOptions={{
          checkOrigin: false,
        }}
        src={`https://sketchfab.com/models/9953cedf0cfa48f6965ae3493c59f1fd/embed?autostart=1&annotations_visible=1`}
        className={classes.iframe}
      />
    </div>
  );
};

export default Pelletheizung3DIframe;
